import React from 'react';
import AdForm from './AdForm';
import ManagedTableCard from '../../../../components/ui/ManagedTableCard';
import { useFetchList } from '../../../../hooks/useFetchList';

const imageBodyTemplate = (advertisement) => (
  <img src={advertisement.image} alt={advertisement.image} className="w-2rem shadow-2 border-round" style={{ width: '80%' }} />
);

const COLUMNS = [
  { field: 'title', header: 'Title' },
  { field: 'image', header: 'Image Url', body: imageBodyTemplate, exportable: false },
  { field: 'description', header: 'Description' },
  { field: 'callToActionURL', header: 'Call To Action URL' },
];

const AdsTable = () => {
  const { rows } = useFetchList('advertisement/all');

  return (
    <ManagedTableCard
      title="Manage Advertisements"
      exportName="Ads"
      columns={COLUMNS}
      rows={rows}
      emptyMessage="No advertisements found"
      createLabel="Create new"
      createHeader="Add new advertisement"
      editHeader="Edit user"
      successMessage="User registered successfully"
      renderCreateForm={(onDone) => <AdForm onCloseDialog={onDone} />}
      renderEditForm={(row, onDone) => <AdForm activeAds={row} onCloseDialog={onDone} />}
    />
  );
};

export default AdsTable;
